import React, { useState } from 'react';
import cx from 'classnames';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import GradientPill from '@test_prep/app/ai_tutor/components/gradient_pill';
import { GraduateCapIcon } from '@test_prep/app/ai_tutor/components/icons';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  examName: string;
}

export default (props: Props) => {
  const [dismissed, setDismissed] = useState<boolean>(false);

  const dismiss = () => {
    setDismissed(true);

    fetch(paths.api.dismissBanner('ai_tutor_dashboard_card'), {
      method: 'PUT'
    });
  };

  const launchTutor = () => {
    const launchTutorEvent = new CustomEvent(
      'aiTutor.launchSkill',
      {
        detail: {
          domain: {
            klass: 'TestPrep::AI::TutoringSessions::Domains::Tutor',
            name: `${props.examName} Tutor`
          }
        }
      }
    );
    document.dispatchEvent(launchTutorEvent);
  };

  if (dismissed) {
    return (
      <CardLayout.Card className="d-flex flex-1 gap-m">
        <div
          className="align-items-center d-flex justify-content-center"
          style={{
            background: 'linear-gradient(to right, #26B67C, #9B51E0)',
            borderRadius: '50%',
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 4px 24px 0px, inset rgba(0, 0, 0, 0.15) 0px 0px 0px 3px',
            color: '#fff',
            height: 40,
            width: 40
          }}
        >
          <GraduateCapIcon size={20} />
        </div>

        <div className="text-gray-light u-margin-V-xxs">
          We won't show this hint again.
        </div>
      </CardLayout.Card>
    );
  } else {
    return (
      <div style={{ position: 'relative', zIndex: 1 }}>
        <CardLayout.Card className={cx(style.featuredCard, 'd-flex flex-1')} style={{ gap: 30 }}>
          <div
            className="align-items-center d-flex flex-none justify-content-center"
            style={{
              background: 'linear-gradient(to right, #26B67C, #9B51E0)',
              borderRadius: '50%',
              boxShadow: 'rgba(0, 0, 0, 0.15) 0px 4px 24px 0px, inset rgba(0, 0, 0, 0.15) 0px 0px 0px 3px',
              color: '#fff',
              height: 60,
              paddingTop: 3,
              width: 60
            }}
          >
            <GraduateCapIcon size={30} />
          </div>

          <div className="d-flex flex-column">
            <div className="d-flex">
              <GradientPill size="sm">
                {props.examName} AI Tutor
              </GradientPill>
            </div>

            <div className="text-gray-darker u-margin-V-xxs">
              <strong>Get Personalized Guidance And Never Get Stuck</strong>
            </div>

            <div className="text-gray-light">
              <ul className="list-unstyled">
                <li>"Am I on track?"</li>
                <li>"What lessons should I watch next?"</li>
                <li>"Recommend practice questions based on my performance."</li>
              </ul>
            </div>

            <div className="align-items-md-center d-flex flex-column flex-md-row gap-s">
              <a
                className="text-bold"
                onClick={launchTutor}
                style={{ color: colors.purple }}
              >
                Launch the AI Tutor
              </a>

              <div className="hidden-xs hidden-sm small text-gray-lighter">
                |
              </div>

              <a
                className="text-gray-light"
                onClick={dismiss}
                style={{ fontSize: 12 }}
              >
                Don't Show Again
              </a>
            </div>
          </div>
        </CardLayout.Card>
      </div>
    );
  }
};
